/**
 * A CMMD project's numeric id, or `null` when the value on hand is not one.
 *
 * CMMD ids cross the wire as numbers and are carried through Forge as strings,
 * so every consumer has to narrow before it can act. Three call sites each kept
 * a private copy of this parse; the copies agreed, but each of them feeds a
 * destructive or navigational decision, and three places to change is three
 * chances for one to start disagreeing.
 *
 * `Number.isInteger` and `> 0` are both load-bearing: `Number("")` is `0`,
 * `Number("abc")` is `NaN`, and a float would be silently truncated by anything
 * downstream that formats it back into a URL.
 */
export function resolveCmmdProjectId(id: string | number | null | undefined): number | null {
  const parsed = Number(id);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}
